mutation DeleteAudience($id: ID!) {
    audienceDelete(input: {id: $id}) {
        audience {
            id
        }
    }
}
